'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.DisplayLocation = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    gap: 10px;\n'], ['\n    gap: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    gap: ', 'px;\n    min-height: 100px;\n    height: ', 'px;\n    width: 100%;\n'], ['\n    display: flex;\n    flex-direction: row;\n    gap: ', 'px;\n    min-height: 100px;\n    height: ', 'px;\n    width: 100%;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    ', ';\n    height: 100%;\n    border-radius: 10px;\n'], ['\n    ', ';\n    height: 100%;\n    border-radius: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _script = require('../../hocs/script');

var _script2 = _interopRequireDefault(_script);

var _alignments = require('../../constants/alignments');

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DisplayContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject);

var AddressContainer = _styledComponents2.default.div(_templateObject2);

var GoogleMapContainer = _styledComponents2.default.div(_templateObject3, function (props) {
	return props.isMobile ? 14 : 28;
}, function (props) {
	return props.size / 2 - (props.isMobile ? 7 : 14);
});

var GoogleMapView = _styledComponents2.default.div(_templateObject4, function (props) {
	return props.isMobile ? 'width: calc(50% - 7px);' : 'width: calc(50% - 14px);';
});

var LocationPinIcon = function LocationPinIcon() {
	return _react2.default.createElement(
		'svg',
		{ xmlns: 'http://www.w3.org/2000/svg',
			width: '20',
			height: '25',
			viewBox: '0 0 20 25'
		},
		_react2.default.createElement('path', { d: 'M6.24999 13.75H8.74999V10.313H11.25V13.751H13.75V7.81404L9.99999 5.31404L6.24999 7.81404V13.75ZM9.99999 21.687C12.1413 19.8096 14.0411 17.6736 15.656 15.328C16.7389 13.844 17.3783 12.0831 17.5 10.25C17.5372 9.22131 17.3637 8.19587 16.9902 7.23664C16.6167 6.27742 16.0511 5.40466 15.328 4.67201C14.6353 3.9653 13.8052 3.40799 12.8888 3.03443C11.9725 2.66088 10.9893 2.47899 9.99999 2.50001C9.01064 2.47899 8.02749 2.66088 7.11113 3.03443C6.19478 3.40799 5.36467 3.9653 4.67199 4.67201C3.94891 5.40466 3.38325 6.27742 3.00974 7.23664C2.63623 8.19587 2.46276 9.22131 2.49999 10.25C2.6217 12.0831 3.26113 13.844 4.34398 15.328C5.95884 17.6736 7.85871 19.8096 9.99999 21.687ZM9.99999 25C7.15505 22.6919 4.6278 20.0177 2.48398 17.047C0.996335 15.0788 0.131281 12.7107 -1.08872e-05 10.247C-0.0637891 8.85842 0.172627 7.47242 0.693104 6.18348C1.21358 4.89454 2.00589 3.73298 3.016 2.77803C4.89354 0.978087 7.3991 -0.0185573 9.99999 1.07265e-05C12.6013 -0.0177516 15.1069 0.979982 16.984 2.78102C17.9941 3.73597 18.7864 4.89753 19.3069 6.18647C19.8274 7.47541 20.0638 8.86142 20 10.25C19.8687 12.7137 19.0036 15.0818 17.516 17.05C15.372 20.0196 12.8447 22.6928 9.99999 25Z',
			fill: _colors.Colors.StrokeMedium
		})
	);
};

var DisplayLocation = exports.DisplayLocation = function DisplayLocation(_ref) {
	var address = _ref.address,
	    top = _ref.top,
	    bottom = _ref.bottom,
	    left = _ref.left,
	    right = _ref.right,
	    defaultMapView = _ref.defaultMapView;

	var _useState = (0, _react.useState)(false),
	    _useState2 = _slicedToArray(_useState, 2),
	    loaded = _useState2[0],
	    setLoaded = _useState2[1];

	var _useState3 = (0, _react.useState)(0),
	    _useState4 = _slicedToArray(_useState3, 2),
	    containerSize = _useState4[0],
	    setContainerSize = _useState4[1];

	var containerRef = (0, _react.useRef)(null);

	var isMobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());

	var handleScriptLoad = function handleScriptLoad() {
		if (address && address.location && address.location.longitude && address.location.latitude) {
			var latitude = parseFloat(address.location.latitude);
			var longitude = parseFloat(address.location.longitude);

			// Initialize map options
			var mapOptions = {
				center: { lat: latitude, lng: longitude },
				zoom: 14,
				mapTypeId: defaultMapView ? google.maps.MapTypeId.ROADMAP : google.maps.MapTypeId.SATELLITE,
				disableDefaultUI: true,
				zoomControl: false,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				clickableIcons: false
			};

			// Create and assign the map instance to a variable
			var map = new google.maps.Map(document.getElementById('MapView'), mapOptions);

			// Create a marker and associate it with the map
			var marker = new google.maps.Marker({
				position: { lat: latitude, lng: longitude },
				map: map,
				title: 'Property Location',
				icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png' // Blue marker
			});

			// Handle Street View
			var streetViewService = new google.maps.StreetViewService();
			var location = new google.maps.LatLng(latitude, longitude);

			streetViewService.getPanorama({ location: location, radius: 50 }, function (data, status) {
				if (status === google.maps.StreetViewStatus.OK) {
					var heading = google.maps.geometry.spherical.computeHeading(data.location.latLng, location);

					var streetViewOptions = {
						position: location,
						pov: {
							heading: heading,
							pitch: 0,
							zoom: 1
						},
						linksControl: false,
						panControl: false,
						enableCloseButton: false,
						clickToGo: false,
						motionTracking: false,
						zoomControl: false,
						addressControl: false,
						fullscreenControl: false
					};

					var streetViewPanorama = new google.maps.StreetViewPanorama(document.getElementById('StreetView'), streetViewOptions);

					// Link the Street View to the main map
					map.setStreetView(streetViewPanorama);
				} else {
					console.warn('Street View data not found for this location.');
					// Optionally, hide the StreetView element or display a placeholder
					document.getElementById('StreetView').style.display = 'none';
				}
			});

			setLoaded(true);
		}
	};

	var updateContainerSize = function updateContainerSize() {
		if (containerRef.current) {
			setContainerSize(containerRef.current.offsetWidth);
		}
	};

	(0, _react.useEffect)(function () {
		updateContainerSize();
		window.addEventListener('resize', updateContainerSize);

		return function () {
			window.removeEventListener('resize', updateContainerSize);
		};
	}, []);

	(0, _react.useEffect)(function () {
		if (!loaded && document.getElementById('gMaps') && typeof google !== 'undefined' && address && address.location && address.location.longitude && address.location.latitude) {
			handleScriptLoad();
		}
	}, [loaded, address]);

	return _react2.default.createElement(
		DisplayContainer,
		{
			fullWidth: true,
			top: top,
			bottom: bottom,
			left: left,
			right: right
		},
		_react2.default.createElement(
			AddressContainer,
			null,
			_react2.default.createElement(LocationPinIcon, null),
			_react2.default.createElement(_label2.default, {
				textAlign: _alignments.Alignments.left,
				text: address.formattedAddress,
				left: _sizes.Sizes.xs,
				size: isMobile ? _sizes.Sizes.sm : _sizes.Sizes.lg,
				color: _colors.Colors.PrimaryText
			})
		),
		_react2.default.createElement(
			GoogleMapContainer,
			{ ref: containerRef,
				size: containerSize,
				isMobile: isMobile
			},
			_react2.default.createElement(GoogleMapView, { id: 'StreetView',
				isMobile: isMobile
			}),
			_react2.default.createElement(GoogleMapView, { id: 'MapView',
				isMobile: isMobile
			})
		)
	);
};

DisplayLocation.propTypes = {
	address: _propTypes2.default.shape({
		formattedAddress: _propTypes2.default.string,
		location: _propTypes2.default.shape({
			latitude: _propTypes2.default.string,
			longitude: _propTypes2.default.string
		})
	}),
	defaultMapView: _propTypes2.default.bool,
	top: _propTypes2.default.string,
	bottom: _propTypes2.default.string,
	left: _propTypes2.default.string,
	right: _propTypes2.default.string
};

exports.default = (0, _script2.default)(DisplayLocation, 'gMaps', 'https://maps.googleapis.com/maps/api/js?libraries=places,geometry&key=@&gMaps&@');